import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import CommonButton from "../../ui/inputs/CommonButton.js";
import { colors } from "../../../../theme/colors.js"
const PopularGamesCard = ({
  image,
  title,
  type,
  description,
  infoLabel,
  infoValue,
  buttonText = "Play Now",
  onClick,
  accentColor = colors.primary.main,
}) => {
  return (
    <Box
      sx={{
        position: "relative", 
        width: "100%", 
        maxWidth: "280px", 
        minHeight: "300px",
        borderRadius: "16px", 
        overflow: "hidden", 
        display: "flex", 
        flexDirection: "column",
        background: (theme) => `linear-gradient(145deg, ${theme.custom.colors.alpha.white[90]}, rgba(244,248,255,0.72))`,
        border: (theme) => `1px solid ${theme.custom.colors.alpha.white[90]}`, 
        boxShadow: "0 8px 24px rgba(70,100,140,0.14)",
        backdropFilter: "blur(16px)", 
        WebkitBackdropFilter: "blur(16px)",
        transition: "transform 0.35s ease, box-shadow 0.35s ease",
        "&:hover": {
          transform: "scale(1.05)",
          boxShadow: "0 16px 40px rgba(70,100,140,0.22)",
        },
        "&:hover .popular-games-card-image": { transform: "scale(1.15)", opacity: 1 },
        "&:hover .popular-games-card-overlay": { opacity: 0 },
      }}
    >
      {/* Background Image with Masking */}
      <Box
        className="popular-games-card-image"
        sx={{
          position: "absolute", 
          inset: "-5%", 
          width: "110%", 
          height: "110%", 
          pointerEvents: "none",
          backgroundImage: `url(${image})`, 
          backgroundPosition: "center", 
          backgroundSize: "cover", 
          backgroundRepeat: "no-repeat",
          maskImage: (theme) => `linear-gradient(135deg, transparent 0%, ${theme.custom.colors.alpha.black[25]} 28%, ${theme.custom.colors.alpha.black[75]} 55%, ${theme.palette.common?.black || "#000"} 78%)`,
          WebkitMaskImage: (theme) => `linear-gradient(135deg, transparent 0%, ${theme.custom.colors.alpha.black[25]} 28%, ${theme.custom.colors.alpha.black[75]} 55%, ${theme.palette.common?.black || "#000"} 78%)`,
          opacity: 0.95, 
          transform: "scale(1)", 
          transformOrigin: "center center",
          transition: "transform 0.55s ease, opacity 0.35s ease", 
          willChange: "transform",
        }}
      />

      {/* Glass Overlay (Fades on hover) */}
      <Box
        className="popular-games-card-overlay"
        sx={{
          position: "absolute", 
          inset: 0, 
          pointerEvents: "none", 
          transition: "opacity 0.35s ease",
          background: (theme) => `linear-gradient(135deg, ${theme.custom.colors.alpha.white[82]} 0%, ${theme.custom.colors.alpha.white[55]} 38%, ${theme.custom.colors.alpha.white[12]} 75%, rgba(255,255,255,0) 100%)`,
        }}
      />

      {/* Card Content Container */}
      <Box sx={{ position: "relative", zIndex: 2, height: "100%", minHeight: "340px", display: "flex", flexDirection: "column", p: 1.75, boxSizing: "border-box" }}>
        
        {/* Header: Title & Type Badge */}
        <Stack 
        direction="row" 
        alignItems="center" 
        justifyContent="space-between" 
        spacing={1}>
          <Typography 
          component="h3" 
          sx={{ 
            fontSize: "16px", 
            lineHeight: 1.2, 
            fontWeight: 700, 
            color: "secondary.dark"
            }}>
            {title}
          </Typography>

          <Box
            sx={{
              flexShrink: 0, 
              px: 1, 
              py: 0.35, 
              borderRadius: "999px",
              backgroundColor: `${accentColor}18`, 
              color: accentColor,
              fontSize: "8px", 
              lineHeight: 1.2, 
              fontWeight: 700, 
              letterSpacing: "0.3px",
            }}
          >
            {type}
          </Box>
        </Stack>

        {/* Description */}
        <Typography 
        sx={{
           mt: 0.7, 
           maxWidth: "62%", 
           fontSize: "10px", 
           lineHeight: 1.4, 
           color: "custom.colors.alpha.navy[58]" }}>
          {description}
        </Typography>

        {/* Game Information (Pushed to bottom) */}
        <Box 
        sx={{ mt: "auto", mb: 1.3 }}>
          <Typography 
          sx={{ 
            fontSize: "9px", 
            lineHeight: 1.2, 
            color: "custom.colors.alpha.navy[52]", 
            mb: 0.35 
            }}>
            {infoLabel}
          </Typography>
          <Typography 
          sx={{ 
            fontSize: "16px", 
            lineHeight: 1.15, 
            fontWeight: 700, 
            color: "secondary.dark" 
            }}>
            {infoValue}
          </Typography>
        </Box>

        {/* Call to Action */}
        <CommonButton
          variant="contained"
          size="small"
          fullWidth
          onClick={onClick}
          label={buttonText}
          sx={{
            minHeight: "36px", 
            height: "36px", 
            py: 0, 
            px: 2, 
            borderRadius: "7px",
            backgroundColor: accentColor, 
            boxShadow: `0 5px 12px ${accentColor}35`,
            "&:hover": { 
                backgroundColor: accentColor, 
                filter: "brightness(0.95)" 
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default PopularGamesCard;